import React from 'react';
import { ArrowDownIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useFAQ } from 'modules/global';

export const HomeScreenFAQ = () => {
  const t = useTranslations();
  const { faq } = useFAQ();

  return (
    <div className="mx-auto my-7 max-w-[54rem] px-2 lg:px-0">
      <div className="mt-6">
        <h6 className="text-center text-base font-semibold sm:text-2xl">{t('tez_tez_beriladigon_savollar')}</h6>

        <div className="mt-8.5 space-y-3">
          {faq?.map((faq, index) => (
            <details
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className="text-md group  rounded-xl border border-transparent  bg-white transition md:text-lg"
            >
              <summary className="flex cursor-pointer items-center justify-between rounded-xl bg-white px-3 py-4 font-medium">
                <span>{faq?.question}</span>
                <span className="-rotate-90 text-green-500 transition-transform duration-300 group-open:rotate-0">
                  <ArrowDownIcon />
                </span>
              </summary>
              <div className="max-h-0 overflow-hidden px-4 pb-4 font-normal text-gray-600 transition-all duration-300 group-open:max-h-[500px]">
                {faq?.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
};
